import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-i_add",
  "use": "icon-i_add-usage",
  "viewBox": "0 0 34.02 34.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.02 34.02\" id=\"icon-i_add\"><title>icon_画板</title><path d=\"M17,31.54A14.54,14.54,0,0,1,6.73,6.73a14.55,14.55,0,0,1,20.55,0h0A14.54,14.54,0,0,1,17,31.54ZM17,4.71a12.29,12.29,0,1,0,8.7,3.6h0A12.22,12.22,0,0,0,17,4.71Z\" /><path d=\"M23.38,18.13H10.63a1.12,1.12,0,1,1,0-2.24H23.38a1.12,1.12,0,0,1,0,2.24Z\" /><path d=\"M17,24.5a1.12,1.12,0,0,1-1.11-1.12V10.63a1.12,1.12,0,1,1,2.23,0V23.38A1.12,1.12,0,0,1,17,24.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol